import { __awaiter } from 'tslib';
import { ContextClassBase } from '../RuntimeContext.js';

class BaseProcessor extends ContextClassBase {
    execute(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let i = item;
            i = yield this.before(i);
            i = yield this.process(i);
            i = yield this.after(i);
            return i;
        });
    }
    before(item) {
        return __awaiter(this, void 0, void 0, function* () {
            return item;
        });
    }
    after(item) {
        return __awaiter(this, void 0, void 0, function* () {
            return item;
        });
    }
}

export { BaseProcessor };
//# sourceMappingURL=BaseProcessor.js.map
